'use es6';

import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { FETCH_INBOXES_REQUEST, FETCH_INBOXES_RESPONSE, FETCH_INBOXES_ERROR, FETCH_CURRENT_INBOX_REQUEST, FETCH_CURRENT_INBOX_RESPONSE, CLEAR_CURRENT_INBOX_RESPONSE, FETCH_CURRENT_INBOX_ERROR } from 'FormsUI/actions/Inboxes';
const inboxes = combineReducers({
  requested: handleActions({
    [FETCH_INBOXES_REQUEST]: () => true,
    [FETCH_INBOXES_ERROR]: () => false,
    [FETCH_INBOXES_RESPONSE]: () => false
  }, false),
  value: handleActions({
    [FETCH_INBOXES_RESPONSE]: (__, {
      inboxes: value
    }) => value
  }, []),
  error: handleActions({
    [FETCH_INBOXES_REQUEST]: () => false,
    [FETCH_INBOXES_ERROR]: () => true,
    [FETCH_INBOXES_RESPONSE]: {
      next() {
        return false;
      },
      throw() {
        return true;
      }
    }
  }, false),
  requestSuccess: handleActions({
    [FETCH_INBOXES_RESPONSE]: () => true
  }, false)
});
const current = combineReducers({
  requested: handleActions({
    [FETCH_CURRENT_INBOX_REQUEST]: () => true,
    [CLEAR_CURRENT_INBOX_RESPONSE]: () => false,
    [FETCH_CURRENT_INBOX_RESPONSE]: {
      next() {
        return false;
      },
      throw() {
        return false;
      }
    }
  }, false),
  value: handleActions({
    [FETCH_CURRENT_INBOX_RESPONSE]: {
      next(state, {
        payload
      }) {
        if (!payload) {
          return state;
        }
        const {
          id,
          name
        } = payload.inbox || payload;
        return {
          id,
          name
        };
      },
      throw() {
        return {};
      }
    },
    [CLEAR_CURRENT_INBOX_RESPONSE]: () => ({}),
    [FETCH_CURRENT_INBOX_ERROR]: () => ({})
  }, {}),
  error: handleActions({
    [FETCH_CURRENT_INBOX_REQUEST]: () => false,
    [CLEAR_CURRENT_INBOX_RESPONSE]: () => false,
    [FETCH_CURRENT_INBOX_ERROR]: () => true,
    [FETCH_CURRENT_INBOX_RESPONSE]: {
      next() {
        return false;
      },
      throw() {
        return true;
      }
    }
  }, false),
  requestSuccess: handleActions({
    [FETCH_CURRENT_INBOX_RESPONSE]: () => true
  }, false)
});
export default combineReducers({
  inboxes,
  current
});